module.exports = __webpack_public_path__ + "static/media/paid-search.31e65da2.svg";